module.exports = __webpack_public_path__ + "static/media/stream.da3a84cc.svg";